export default "__VITE_ASSET__DMUxqGEG__"